export default defineNuxtPlugin(() => {
  return {
    provide: {
      initCarousel: (selector, options = {}) => {
        const defaultOptions = {
          items: 1,
          autoPlay: 5000,
          stopOnHover: true,
          addClassActive: true,
          pagination: true,
          navigation: true,
          navigationText: ['', ''],
          itemsDesktop: false,
          itemsDesktopSmall: false,
        }
        
        if (typeof window !== 'undefined' && window.$?.fn?.owlCarousel) {
          window.$(selector).owlCarousel({ ...defaultOptions, ...options })
        }
      }
    }
  }
})
